import { useCallback, useEffect, useRef, useState } from 'react';

export const useMultiHeaderHeight = () => {
  const elementsRef = useRef<Set<HTMLDivElement>>(new Set());
  const [totalHeight, setTotalHeight] = useState<number>(0);

  const register = useCallback((el: HTMLDivElement | null) => {
    if (el) {
      elementsRef.current.add(el);
    }
  }, []);

  const updateHeight = useCallback(() => {
    requestAnimationFrame(() => {
      const validElements = Array.from(elementsRef.current).filter((el) => document.body.contains(el));
      elementsRef.current = new Set(validElements); // 제거된 DOM 정리

      const heightSum = validElements.reduce((sum, el) => sum + el.offsetHeight, 0);
      setTotalHeight(heightSum);
    });
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(updateHeight);

    const observeElements = () => {
      elementsRef.current.forEach((el) => {
        if (el && document.body.contains(el)) {
          resizeObserver.observe(el);
        }
      });
    };

    observeElements();
    updateHeight();

    return () => resizeObserver.disconnect();
  }, [updateHeight]);

  return {
    register,
    totalHeight,
    update: updateHeight,
  };
};
